var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ValidatorConstraint } from 'class-validator';
let ValidEnumValues = class ValidEnumValues {
    validate(value, args) {
        const options = args.constraints[0];
        if (options.nullable && value === 'null') {
            return true;
        }
        if (options.nullable && value.includes('null')) {
            const enumValues = Object.values(options.enumType);
            const valuesArray = value
                .split(',')
                .filter((val) => !(options.nullable && val.trim() === 'null'))
                .map((val) => val.trim());
            return valuesArray.every((val) => enumValues.includes(val.trim()));
        }
        else {
            const enumValues = Object.values(options.enumType);
            return value.split(',').every((val) => enumValues.includes(val.trim()));
        }
    }
    defaultMessage(args) {
        const options = args.constraints[0];
        const enumValues = Object.values(args.constraints[0]);
        const value = args.value;
        if (options.nullable && value.includes('null')) {
            const valuesArray = value
                .split(',')
                .filter((val) => !(options.nullable && val.trim() === 'null'))
                .map((val) => val.trim());
            const invalidValues = valuesArray.filter((val) => !enumValues.includes(val));
            return `Invalid values: ${invalidValues}`;
        }
        else {
            const valuesArray = value.split(',').map((val) => val.trim());
            const invalidValues = valuesArray.filter((val) => !enumValues.includes(val));
            return `Invalid values: ${invalidValues}`;
        }
    }
};
ValidEnumValues = __decorate([
    ValidatorConstraint({ name: 'validEnumValues', async: false })
], ValidEnumValues);
export { ValidEnumValues };
